export default __webpack_public_path__ + "static/media/logo.554076a0.png";